interface MailTemplateInterface {
    id: string;
    send_type: number;
    title: string;
    from_address: string;
    from_name: string;
    body: string | null;
}

class MailTemplate implements MailTemplateInterface {
    id: string;
    send_type: number;
    title: string;
    from_address: string;

    from_name: string;
    body: string | null;

    constructor(id: string, send_type: number, title: string, from_address: string, from_name: string, body: string | null) {
        this.id = id;
        this.send_type = send_type;
        this.title = title;
        this.from_address = from_address;
        this.body = body;
        this.from_name = from_name;
    }

    getSendTypeLabel = (): string => {
        switch (this.send_type) {
            case 1:
                return "予約完了";
            case 2:
                return "キャンセル";

            case 14:
                return "振り込み期限";
            case 11:
                return "入金確認";
            case 20:
                return "決済";
            case 21:
                return "自動キャンセル";

            default:
                return "その他";
        }
    };
}

export default MailTemplate;
